import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";
import { Loader2, UserPlus } from "lucide-react";

export default function Register() {
  const [form, setForm] = useState({ name: "", email: "", password: "", user_type: "famiglia" });
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await register(form);
    setLoading(false);
    if (res.ok) { toast.success("Benvenuto nel Network!"); navigate("/"); }
    else toast.error(res.error);
  };

  return (
    <div className="min-h-[calc(100vh-80px)] grid md:grid-cols-2">
      <div className="flex items-center justify-center p-6 md:p-14 bg-[#FBF9F6] order-2 md:order-1">
        <form onSubmit={submit} className="w-full max-w-md">
          <h1 className="font-display font-black text-3xl md:text-4xl text-[#2C312E]">Crea un account</h1>
          <p className="mt-2 text-[#58625B]">Un posto per salvare le fattorie preferite e le tue richieste di visita.</p>

          <div className="mt-6 grid grid-cols-2 gap-2">
            {[
              { k: "famiglia", l: "Sono una Famiglia" },
              { k: "scuola", l: "Rappresento una Scuola" },
            ].map((o) => (
              <button type="button" key={o.k} onClick={() => setForm({ ...form, user_type: o.k })}
                className={`rounded-2xl border-2 p-4 text-left ${form.user_type === o.k ? "border-[#4A6B53] bg-[#4A6B53]/5" : "border-[#E5DCD0] bg-white"}`}
                data-testid={`user-type-${o.k}`}>
                <div className="text-sm font-bold text-[#2C312E]">{o.l}</div>
              </button>
            ))}
          </div>

          <div className="mt-5 space-y-4">
            <Field label="Nome e cognome / Nome scuola" value={form.name} onChange={(v) => setForm({ ...form, name: v })} required testid="register-name"/>
            <Field label="Email" type="email" value={form.email} onChange={(v) => setForm({ ...form, email: v })} required testid="register-email"/>
            <Field label="Password" type="password" value={form.password} onChange={(v) => setForm({ ...form, password: v })} required testid="register-password"/>
          </div>

          <button type="submit" disabled={loading} className="mt-6 w-full inline-flex items-center justify-center gap-2 rounded-full bg-[#C8795A] text-white py-4 font-bold hover:bg-[#B3684B] disabled:opacity-60 transition-all" data-testid="register-submit">
            {loading ? <Loader2 size={18} className="animate-spin"/> : <UserPlus size={16}/>} Registrati
          </button>
          <p className="mt-6 text-sm text-[#58625B] text-center">
            Hai già un account? <Link to="/login" className="font-bold text-[#4A6B53] hover:underline">Accedi</Link>
          </p>
        </form>
      </div>
      <div className="hidden md:block relative order-1 md:order-2">
        <img src="https://images.pexels.com/photos/8033891/pexels-photo-8033891.jpeg?auto=compress&cs=tinysrgb&w=1600" alt="" className="absolute inset-0 w-full h-full object-cover"/>
        <div className="absolute inset-0 bg-gradient-to-bl from-[#2C312E]/70 to-[#C8795A]/40"/>
        <div className="relative h-full flex items-end p-12">
          <div>
            <div className="text-xs font-bold uppercase tracking-[0.25em] text-[#E4B871] mb-3">Benvenuti</div>
            <h2 className="font-display font-black text-4xl text-white leading-tight">
              Impara fuori.<br/>Vivi dentro la natura.
            </h2>
          </div>
        </div>
      </div>
    </div>
  );
}

function Field({ label, value, onChange, type = "text", required, testid }) {
  return (
    <label className="block">
      <span className="text-xs font-bold uppercase tracking-wider text-[#7A7369]">{label}</span>
      <input type={type} value={value} onChange={(e) => onChange(e.target.value)} required={required}
        className="mt-2 w-full h-12 rounded-xl border-2 border-[#E5DCD0] bg-white px-4 focus:outline-none focus:ring-2 focus:ring-[#4A6B53] focus:border-transparent"
        data-testid={testid}/>
    </label>
  );
}
